import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import TableComponent from "../../TableComponent/TableComponent";
import {  fetchMergeRequestBrandList, fetchPaginateMergeBrandList, resetMergeRequestBrandTable, updateMergeRequestBrandListRequestBody, updateRequestBodyForMergeRequestTable } from "../../../redux/LivePlatform/LivePlatformAction";
import MergeRequestTabTableColumn from "./MergeRequestTabTableColumn";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function MergeRequestTabComponent() {
  const mergedDuplicateBrandDetails = useSelector((state: RootState) => state.livePlatformState.duplicateBrandState.mergedDuplicateBrandDetails);
   const dispatch = useAppDispatch();
  function handleTableSorting(sortOrder: any): void {
     const isAscend = (order: string) => {
       if (order === "ascend") {
         return true;
       }
       return false;
     };
     const newSortingRequestBody = {
       ...mergedDuplicateBrandDetails.currentRequestBody,
       SortColumn: sortOrder.field,
       isAsc: isAscend(sortOrder.order),
     };
    
      dispatch(resetMergeRequestBrandTable());
       dispatch(updateRequestBodyForMergeRequestTable(newSortingRequestBody));
       dispatch(fetchMergeRequestBrandList(newSortingRequestBody));
   }
  return (
    <div className="body-container pt-3 h-100 gap-3"  key={1}>
     <TableComponent
            columns={MergeRequestTabTableColumn}
            dataSource={mergedDuplicateBrandDetails.mergeBrandDetails}
            pagination={mergedDuplicateBrandDetails.pagination}
            handleTableSorting={handleTableSorting}
            loading={mergedDuplicateBrandDetails.loading}
            fetchPaginatedData={() => fetchPaginateMergeBrandList({})}
            tableKey="mergeRequestTabTable"
          />
    </div>
  );
}
export default MergeRequestTabComponent;